import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewFaculty from "./ViewFaculty";
import { toast } from "react-toastify";
import FacultysInBulk from "../../../../BulkCSVFilder/FacultysInBulk.csv";


function Faculty() {
  const classes = useStyles();
    const handleDownload = () => {
      const link = document.createElement("a");
      link.href = FacultysInBulk;
      link.setAttribute("download", "FacultysInBulk.csv");
  
      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();
  
      // Check if the download started (link exists in document)
      if (document.body.contains(link)) {
        toast.success("Sample file for adding faculty in bulk has been downloaded");
      } else {
        toast.error("Failed to download the bulk faculty file. Please try again.");
      }
  
      // Clean up
      link.parentNode.removeChild(link);
    };
  const Heading = [
    {
      id: 1,
      pageicon:<SubjectIcon />,
      mainheading: "Faculty",
      subhead: "Want to Add in Bulk ?",
      downloadlink: "Download bulk Sample Files",
      addbtntext:"Create New Faculty",
      onDownload: handleDownload,
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addfaculty",
      showDownloadButton: true,
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewFaculty/>
    </div>
  );
}
export default Faculty;